
















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import { Utils } from "@/core/Utils";
import NameValue from "@/models/nameValue.model";
import TipoTramite from "@/models/tipoTramite";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import TramiteLiberacion from "../../models/tramite/liberacion-sancion-observacion/index.model";
@Component({
  components: {
    DatePickerComponent
  }
})
export default class SolicitudLiberacionSacionObservacionResumen extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;

  model: TramiteLiberacion | null = null;
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get sancion() {
    if (this.model && this.model.sancion) return this.model.sancion;
    return 0;
  }
  get observacion() {
    if (this.model && this.model.observacion) return this.model.observacion;
    return 0;
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }
  get generaCambioDireccion() {
    if (this.model && this.model.razonCodigo)
      return this.model.razonCodigo === "RealizoUnCambioDeDireccion";
    return "";
  }
  direccionId = 0;
  verResumenCD() {
    if (this.direccionId)
      this.$router.push(`/resumen-solicitud/${this.direccionId}`);
  }
  result: any = {};
  async mounted() {
    if (this.tramiteBeneficiarioId) {
      this.result = await new BaseHttpClient(
        "TramiteBeneficiarioResumen"
      ).getAsync("GetLiberacion", {
        tramiteId: this.tramiteBeneficiarioId
      });

      this.model = this.result.model;
      this.direccionId = this.result.direccionId;
    }
  }
}
